module.exports = __webpack_public_path__ + "static/media/acash.cac7d1aa.png";